import * as Yup from "yup";
import i18next from "../../../i18n";

/**
 * Values `UserGroupForm` runs through React Hook Form + Yup. Membership (`selectedIds`) is
 * deliberately NOT part of this — it's tracked as its own `useState` in the form component, the
 * same split the pre-Carbon form used: there has never been a rule requiring at least one
 * member, so there is nothing here for Yup to validate.
 */
export type UserGroupFormValues = {
  name: string;
};

/**
 * Validation for the create/edit group form (`POST` / `PUT /api/user-groups`), extracted out of
 * `UserGroupForm.tsx` so the rule is testable without rendering the form — same reasoning
 * `newUserValidationSchema.ts`/`editUserValidationSchema.ts` document.
 *
 * `.trim()` is load-bearing, not decorative: it transforms the value before `.required()` runs,
 * which is what makes a whitespace-only name fail too — the same behaviour the pre-Carbon form
 * got by calling `name.trim()` itself before checking it was non-empty. See this schema's own
 * test file for the mutation-tested proof.
 */
export const userGroupValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required(i18next.t("userGroups.nameRequired")),
});
